import styled from 'styled-components';
import { Box, Heading, Paragraph } from '@99designs/emu';

export type Reason = {
    heading: string;
    description: React.ReactNode;
    icon: React.ReactNode;
};

type ReasonCardProps = {
    reason: Reason;
};

const StyledSvgWrapper = styled(Box)`
    svg {
        height: 100%;
    }
`;

export const ReasonCard = ({ reason }: ReasonCardProps) => {
    return (
        <Box width={['100%', '50%']} display="flex" paddingTop={['1.5bu', '2bu']}>
            <StyledSvgWrapper height="40px" width="40px">
                {reason.icon}
            </StyledSvgWrapper>
            <Box display="flex" flexDirection="column" paddingLeft="1bu">
                <Heading appearanceLevel={5} accessibilityLevel={3}>
                    {reason.heading}
                </Heading>
                <Box paddingTop="0.5bu">
                    <Paragraph>{reason.description}</Paragraph>
                </Box>
            </Box>
        </Box>
    );
};
